<template>
  <div>
    <PageTitle :route="$route">
      <!-- <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          @click="() => {}"
        />
      </template> -->
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <SendCommandForm />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  // import ActionButton from '@/components/button/ActionButton'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import SendCommandForm from '@/components/sendcommands/SendCommandForm'

  export default {
    name: 'SendCommand',
    components: {
      PageTitle,
      // ActionButton,
      PageRowWrapper,
      SendCommandForm
    }
  }
</script>